import type { LegalDocumentId } from '@/components/legal/legal-content'
import type { SignupLegalConfig } from '@/constants/signup'

const IN_APP_LEGAL_HREF: Record<LegalDocumentId, string> = {
  terms: '/legal/terms',
  privacy: '/legal/privacy',
}

/** Same rule as `LandingCtaLink`: only http(s) leaves the app. */
export function isAbsoluteHttpUrl(url: string): boolean {
  return url.startsWith('http://') || url.startsWith('https://')
}

export function legalDocumentHref(
  documentId: LegalDocumentId,
  legal: Pick<SignupLegalConfig, 'termsUrl' | 'privacyUrl'> | null | undefined,
): string {
  const configured = documentId === 'terms' ? legal?.termsUrl : legal?.privacyUrl
  const trimmed = configured?.trim()
  return trimmed || IN_APP_LEGAL_HREF[documentId]
}

/** Send the browser to an absolute legal URL. No-op when there is no `window` (static render). */
export function redirectBrowserTo(href: string): void {
  if (typeof window === 'undefined') return
  window.location.replace(href)
}
